<template>
    <div class="text-center">
        <md-icon>sentiment_dissatisfied</md-icon>
        <h5>Sorry, no products to show you...</h5>
    </div>
</template>
<script>
export default {
    name: "NoProducts"
}
</script>
<style lang="scss" scoped>

</style>